"function" != typeof Promise && require("promise-polyfill/dist/polyfill");